<agr-page-toolbar
  [isEmpty]="(cycle$ | async)?.departures.length === 0"
  [emptyTitle]="'departure.no-departures-title' | translate"
  [emptyDescription]="'departure.no-departures-description' | translate"
  emptyImage="assets/images/arrival.jpg"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="addDialog()"
  data-test="departure-overview"
>
  <ng-container *ngIf="(isLoading$ | async) === false && cycle$ | async as cycle">
    <mat-nav-list role="list" *ngIf="cycle?.departures?.length" class="departure-overview__list">
      <a
        mat-list-item
        *ngFor="let departure of sort(cycle.departures)"
        role="listitem"
        class="departure-item"
        [attr.data-test]="'departure-overview__item_' + departure.id"
        (click)="openDepartureEdit(departure.id)"
      >
        <mat-icon
          matListItemIcon
          matListItemAvatar
          class="list-avatar"
          svgIcon="mdi-inbox-arrow-up"
        ></mat-icon>
        <div matListItemTitle>
          {{ departure.departureDate | date }}
        </div>
        <div matListItemLine class="text--gray">
          {{ departure?.propagationCompany?.name }}
        </div>
        <div matListItemLine class="text--gray">
          {{ 'movement.numberOfAnimals' | translate }}: {{ getTotalAnimals(departure) | agrNumber }}
        </div>
        <button
          matListItemMeta
          mat-icon-button
          (click)="delete($event, departure)"
          data-test="departure-overview__delete-item"
        >
          <mat-icon iconPositionEnd>delete</mat-icon>
        </button>
      </a>
      <mat-divider *ngIf="cycle.departures.length > 0"></mat-divider>
    </mat-nav-list>
  </ng-container>
</agr-page-toolbar>
